import { createStore as createZustandStore } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import type { BuildingLine } from "../../tools/BuildingLineTool";
import type { ProjectArea } from "../../tools/ProjectAreaTool";
import type { Zone } from "../../tools/ZoneTool";

type ZoneToolMode = "drawing" | "editing" | "picking";

type ValidationIssueKind = "selfIntersection" | "outsideProjectArea" | "outsideCheckZone" | "noBuildingZoneInside";

type ValidationIssue = { shape: Zone | BuildingLine; kind: ValidationIssueKind };

type ValidationStatus = {
	isProjectAreaSet: boolean;
	hasCheckZone: boolean;
	areBuildingZonesValid: boolean;
	areCheckZonesValid: boolean;
	isValid: boolean;
};

type ParcelSelectionMode = "single" | "multiple";

type SelectedParcel = { id: string; numer: string; areaM2: number };

type ParcelSelection = { mode: ParcelSelectionMode; items: ReadonlyArray<SelectedParcel> };

type Kolega3DStoreState = {
	projectArea: ProjectArea | null;
	zones: ReadonlyArray<Zone>;
	buildingLines: ReadonlyArray<BuildingLine>;
	zoneToolMode: ZoneToolMode;
	isValidationDirty: boolean;
	validationStatus: ValidationStatus;
	validationIssues: ReadonlyArray<ValidationIssue>;
	parcelSelection: ParcelSelection;
};

const INITIAL_STATE: Kolega3DStoreState = {
	projectArea: null,
	zones: [],
	buildingLines: [],
	zoneToolMode: "drawing",
	isValidationDirty: false,
	validationStatus: { isProjectAreaSet: false, hasCheckZone: false, areBuildingZonesValid: false, areCheckZonesValid: false, isValid: false },
	validationIssues: [],
	parcelSelection: { mode: "single", items: [] },
};

function createStore() {
	return createZustandStore(subscribeWithSelector(() => INITIAL_STATE));
}

export type { Kolega3DStoreState, ParcelSelection, ParcelSelectionMode, SelectedParcel, ValidationIssue, ValidationIssueKind, ValidationStatus, ZoneToolMode };
export { createStore };
